import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="canvasgradient" id="canvasgradient"></a>
    <h1 {...{
      "id": "windowcanvasgradient"
    }}>{`window.CanvasGradient`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasGradient"
      }}>{`Web APIs - CanvasGradient`}</a>{` for more details`}<br></br>{`
Also, refer to the interface `}<a parentName="p" {...{
        "href": "../HTML%20Elements/HTMLCanvasElement.md#module:global.htmlcanvaselement"
      }}>{`HTMLCanvasElement`}</a><br></br><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <a name="canvasgradient-addcolorstop" id="canvasgradient-addcolorstop"></a>
    <h2 {...{
      "id": "addcolorstopoffset-colorvalue"
    }}>{`addColorStop(offset, colorValue)`}</h2>
    <p>{`Adds a new color stop, defined by an `}<inlineCode parentName="p">{`offset`}</inlineCode>{` and a `}<inlineCode parentName="p">{`color value`}</inlineCode>{`, to a given canvas gradient.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasGradient/addColorStop"
      }}>{`CanvasGradient - addColorStop`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`offset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A number between 0 and 1, inclusive, representing the position of the color stop. 0 represents the start of the gradient and 1 represents the end.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`colorValue`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A CSS `}<inlineCode parentName="td">{`<color>`}</inlineCode>{` value representing the color of the stop.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      